import { call, fork, put, takeEvery, takeLatest } from 'redux-saga/effects';

import {
  fetchSTRCaseReportByCaseIdSuccess,
  fetchSTRCaseReportByCaseIdFail,
  FETCH_STR_CASE_REPORT_BY_CASE_ID,
  UPDATE_STR_CASE_REPORT_BY_CASE_ID,
  updateSTRCaseReportByCaseIdSuccess,
  updateSTRCaseReportByCaseIdFail,
  CREATE_STR_CASE_REPORT_BY_CASE_ID,
  createSTRCaseReportByCaseIdSuccess,
  createSTRCaseReportByCaseIdFail,
  FETCH_REPORT_METADATA,
  fetchReportMetadataSuccess,
  fetchReportMetadataFail,
  fetchTransactionListSuccess,
  fetchTransactionListFail,
  FETCH_TRANSACTION_LIST,
  FETCH_PARTIES_LIST,
  fetchPartiesListSuccess,
  fetchPartiesListFail,
  FETCH_TRANSACTION_LIST_DOWNLOAD,
  fetchTransactionListDownloadSuccess,
  fetchTransactionListDownloadFail,
  UPDATE_REPORTING_INSTITUTION,
  updateReportingInstitutionSuccess,
  updateReportingInstitutionFail,
  fetchReportMetadata as fetchReportMetadataAction,
  UPDATE_TRANSACTION_LIST,
  updateTransactionListSuccess,
  updateTransactionListFail,
  fetchTransactionList as fetchTransactionListAction,
  UPDATE_PARTIES_LIST,
  updatePartiesListSuccess,
  updatePartiesListFail,
  fetchPartiesList as fetchPartiesListAction,
  UPDATE_INVESTIGATION_DETAILS,
  updateInvestigationDetailsSuccess,
  updateInvestigationDetailsFail
} from '../../redux/actions/cm/caseReport';

import {
  createSTRCaseReportByCaseId,
  fetchSTRCaseReportByCaseId,
  updateSTRCaseReportByCaseId,
  fetchReportMetadata,
  fetchTransactions,
  fetchParties,
  updateReportingInstitution,
  updateTransactionList,
  updatePartiesList
} from '../../services/cm/cases';

let activeTransactionsAbortController;
let activePartiesAbortController;

function* fetchSTRCaseReportByCaseIdWorker(payload) {
  try {
    const caseReportDetails = yield call(fetchSTRCaseReportByCaseId, payload);

    yield put(fetchSTRCaseReportByCaseIdSuccess(caseReportDetails));
  } catch (error) {
    yield put(fetchSTRCaseReportByCaseIdFail(error.message));
  }
}

function* updateSTRCaseReportByCaseIdWorker(reportUpatedFields) {
  try {
    const res = yield call(updateSTRCaseReportByCaseId, reportUpatedFields);

    yield put(updateSTRCaseReportByCaseIdSuccess(res));
  } catch (error) {
    yield put(updateSTRCaseReportByCaseIdFail(error.message));
  }
}

function* createSTRCaseReportByCaseIdWorker({ caseId, alertIds }) {
  try {
    const caseReportDetails = yield call(createSTRCaseReportByCaseId, {
      caseId,
      alertIds
    });

    yield put(createSTRCaseReportByCaseIdSuccess(caseReportDetails));
  } catch (error) {
    yield put(createSTRCaseReportByCaseIdFail(error.message));
  }
}

export function* watchFetchSTRCaseReportByCaseId() {
  yield takeEvery(FETCH_STR_CASE_REPORT_BY_CASE_ID, function* ({ payload }) {
    yield fork(fetchSTRCaseReportByCaseIdWorker, payload);
  });
}

export function* watchUpdateSTRCaseReportByCaseId() {
  yield takeEvery(
    UPDATE_STR_CASE_REPORT_BY_CASE_ID,
    function* ({ payload: { reportUpatedFields } }) {
      yield fork(updateSTRCaseReportByCaseIdWorker, reportUpatedFields);
    }
  );
}

export function* watchCreateSTRCaseReportByCaseId() {
  yield takeEvery(
    CREATE_STR_CASE_REPORT_BY_CASE_ID,
    function* ({ payload: { caseId, alertIds } }) {
      yield fork(createSTRCaseReportByCaseIdWorker, { caseId, alertIds });
    }
  );
}

function* fetchReportMetadataWorker(payload) {
  try {
    const reportMetadata = yield call(fetchReportMetadata, payload);
    yield put(fetchReportMetadataSuccess(reportMetadata));
  } catch (error) {
    yield put(fetchReportMetadataFail(error.message));
  }
}

export function* watchFetchReportMetadata() {
  yield takeEvery(FETCH_REPORT_METADATA, function* ({ payload }) {
    yield fork(fetchReportMetadataWorker, payload);
  });
}

function* fetchTransactionsWorker(payload) {
  try {
    if (activeTransactionsAbortController) {
      activeTransactionsAbortController.abort();
    }
    activeTransactionsAbortController = new AbortController();

    const transactions = yield call(fetchTransactions, {
      ...payload,
      signal: activeTransactionsAbortController.signal
    });
    yield put(fetchTransactionListSuccess(transactions));
  } catch (error) {
    if (
      error?.name === 'CanceledError' ||
      error?.name === 'AbortError' ||
      error?.code === 'ERR_CANCELED'
    ) {
      return;
    }
    yield put(fetchTransactionListFail(error.message));
  }
}

export function* watchFetchTransactions() {
  yield takeLatest(FETCH_TRANSACTION_LIST, function* ({ payload }) {
    yield call(fetchTransactionsWorker, payload);
  });
}

function* fetchPartiesWorker(payload) {
  try {
    if (activePartiesAbortController) {
      activePartiesAbortController.abort();
    }
    activePartiesAbortController = new AbortController();

    const parties = yield call(fetchParties, {
      ...payload,
      signal: activePartiesAbortController.signal
    });
    yield put(fetchPartiesListSuccess(parties));
  } catch (error) {
    if (
      error?.name === 'CanceledError' ||
      error?.name === 'AbortError' ||
      error?.code === 'ERR_CANCELED'
    ) {
      return;
    }
    yield put(fetchPartiesListFail(error.message));
  }
}

export function* watchFetchParties() {
  yield takeLatest(FETCH_PARTIES_LIST, function* ({ payload }) {
    yield call(fetchPartiesWorker, payload);
  });
}

function* fetchTransactionsDownloadWorker(payload) {
  try {
    const transactions = yield call(fetchTransactions, payload);
    yield put(fetchTransactionListDownloadSuccess(transactions));
  } catch (error) {
    yield put(fetchTransactionListDownloadFail(error.message));
  }
}

export function* watchFetchTransactionsDownload() {
  yield takeEvery(FETCH_TRANSACTION_LIST_DOWNLOAD, function* ({ payload }) {
    yield fork(fetchTransactionsDownloadWorker, payload);
  });
}

function* updateReportingInstitutionWorker(payload) {
  try {
    const response = yield call(updateReportingInstitution, payload);
    yield put(updateReportingInstitutionSuccess(response));
    yield put(
      fetchReportMetadataAction({
        reportId: payload.reportId,
        format: payload.format
      })
    );
  } catch (error) {
    yield put(updateReportingInstitutionFail(error.message));
  }
}

export function* watchUpdateReportingInstitution() {
  yield takeLatest(UPDATE_REPORTING_INSTITUTION, function* ({ payload }) {
    yield call(updateReportingInstitutionWorker, payload);
  });
}

function* updateTransactionListWorker(payload) {
  try {
    const { pageSize, ...updatePayload } = payload;
    yield call(updateTransactionList, updatePayload);
    yield put(updateTransactionListSuccess());
    yield put(
      fetchTransactionListAction({
        reportId: payload.reportId,
        format: payload.format,
        page: 1,
        pageSize: pageSize || 10
      })
    );
  } catch (error) {
    yield put(updateTransactionListFail(error.message));
  }
}

export function* watchUpdateTransactionList() {
  yield takeLatest(UPDATE_TRANSACTION_LIST, function* ({ payload }) {
    yield call(updateTransactionListWorker, payload);
  });
}

function* updatePartiesListWorker(payload) {
  try {
    const { pageSize, ...updatePayload } = payload;
    yield call(updatePartiesList, updatePayload);
    yield put(updatePartiesListSuccess());
    yield put(
      fetchPartiesListAction({
        reportId: payload.reportId,
        format: payload.format,
        page: 1,
        pageSize: pageSize || 10
      })
    );
  } catch (error) {
    yield put(updatePartiesListFail(error.message));
  }
}

export function* watchUpdatePartiesList() {
  yield takeLatest(UPDATE_PARTIES_LIST, function* ({ payload }) {
    yield call(updatePartiesListWorker, payload);
  });
}

function* updateInvestigationDetailsWorker(payload) {
  try {
    yield call(updateReportingInstitution, payload);
    yield put(updateInvestigationDetailsSuccess());
    yield put(
      fetchReportMetadataAction({
        reportId: payload.reportId,
        format: payload.format
      })
    );
  } catch (error) {
    yield put(updateInvestigationDetailsFail(error.message));
  }
}

export function* watchUpdateInvestigationDetails() {
  yield takeLatest(UPDATE_INVESTIGATION_DETAILS, function* ({ payload }) {
    yield call(updateInvestigationDetailsWorker, payload);
  });
}
